import React from 'react';
import { connect } from 'react-redux';
import { Row, Col } from 'reactstrap';
import * as MaterialUI from 'material-ui';
import { push } from 'react-router-redux';
import FontAwesome from 'react-fontawesome';

import ItemListC from './itemList';
import * as rutinasActions from 'modules/rutinas/action';
import * as generalActions from 'modules/general/action';
import { EliminarConfirmacionC } from 'modules/general/component';

@connect(store => ({
  rutinas: store.get('rutinas'),
  userRoles: store.getIn(['user', 'roles']),
  eliminarId: store.getIn(['rutinas', 'eliminarId']),
}))
export default class extends React.Component {
  componentDidMount = () => {
    this.props.dispatch(generalActions.dashboard_changeTitle('RUTINAS'));
    if (this.props.rutinas.get('lista').size <= 1) this.props.dispatch(rutinasActions.get());
  };
  add = () => this.props.dispatch(push('/dashboard/rutinas/add/new'));
  delete = rutinaId => this.props.dispatch(rutinasActions.setState({ eliminarId: rutinaId }));
  deleteHorario = () => this.props.dispatch(rutinasActions.setState({ eliminarId: false }));
  confirmDelete = () => {
    this.props.dispatch(rutinasActions.delete_(this.props.eliminarId));
    this.props.dispatch(rutinasActions.setState({ eliminarId: false }));
  };
  render = () => {
    const { eliminarId, userRoles } = this.props;
    return (
      <div>
        <Row className="rowContainer textCenter">
          <Col md={{ size: 8, offset: 2 }}>
            <MaterialUI.Paper zDepth={2} className="container">
              <MaterialUI.List className="noPadding dividerList">
                {this.props.rutinas.get('lista').map(rutina => (
                  <div key={rutina.get('id')}>
                    <ItemListC rutina={rutina} />
                    <MaterialUI.Divider />
                  </div>
                ))}
              </MaterialUI.List>
            </MaterialUI.Paper>
          </Col>
        </Row>
        {userRoles && userRoles.find(v => v == 'admin' || v == 'devAdmin' || v == 'administrador_rutinas') && (
          <MaterialUI.FloatingActionButton className="bottonFlotanteAdd" onTouchTap={this.add.bind(this)}>
            <FontAwesome name="plus" />
          </MaterialUI.FloatingActionButton>
        )}
        <EliminarConfirmacionC eliminarId={eliminarId} confirmar={this.confirmDelete} cancelar={this.deleteHorario} />
      </div>
    );
  };
}



// WEBPACK FOOTER //
// src/modules/rutinas/components/main.js